<div
  class="cv-page cv-7"
  [ngClass]="{ 'thumbnail-view': isThumbnail }"
>
  <div class="cv-inner">
    <!-- LEFT SIDEBAR -->
    <aside class="sidebar">
      <div class="name-block">
        <div class="name-large">
          {{ data.firstName | uppercase }} {{ data.lastName | uppercase }}
        </div>
        <!-- <div class="name-large name-last">{{ data.lastName | uppercase }}</div> -->
        <div
          class="designation"
          *ngIf="data.designation"
        >
          {{ data.designation }}
        </div>
      </div>

      <div class="contact">
        <p
          *ngIf="data.contactDetails?.email"
          class="contact-line"
        >
          <span class="icon mail"></span>
          <span>{{ data.contactDetails.email }}</span>
        </p>
        <p
          *ngIf="data.contactDetails?.number"
          class="contact-line"
        >
          <span class="icon phone"></span>
          <span>{{ data.contactDetails.number }}</span>
        </p>
        <p
          *ngIf="data.contactDetails?.address"
          class="contact-line"
        >
          <span class="icon pin"></span>
          <span>{{ data.contactDetails.address || data?.city }}</span>
        </p>
        <p
          *ngIf="data.contactDetails?.linkedIn"
          class="contact-line"
        >
          <span class="icon linkedin"></span>
          <span>{{ data.contactDetails.linkedIn }}</span>
        </p>
      </div>

      <section
        class="objective"
        *ngIf="data.about"
      >
        <h4>OBJECTIVE</h4>
        <p>{{ data.about }}</p>
      </section>

      <section
        class="education"
        *ngIf="data.educations?.length"
      >
        <h4>EDUCATION</h4>
        <div
          class="edu-item"
          *ngFor="let e of data.educations"
        >
          <div class="edu-degree">{{ e.courseName }}</div>
          <div class="edu-school">{{ e.universityName }}</div>
          <div
            class="edu-date"
            *ngIf="e.formattedDate"
          >
            {{ e.formattedDate }}
          </div>
        </div>
      </section>

      <section
        class="skills"
        *ngIf="data.skills?.length"
      >
        <h4>SKILLS</h4>
        <ul>
          <li *ngFor="let s of data.skills">
            {{ s }}
          </li>
        </ul>
      </section>

      <section
        class="certs"
        *ngIf="data.certifications?.length"
      >
        <h4>CERTS</h4>
        <ul>
          <li *ngFor="let c of data.certifications; trackBy: trackByIndex">
            <b *ngIf="c.authority">{{ c.authority }}:</b>
            <span *ngIf="c.name"> {{ c.name }}</span>
            <span *ngIf="c.date"> ({{ c.date }})</span>
          </li>
        </ul>
      </section>
    </aside>

    <!-- RIGHT MAIN -->
    <main class="main">
      <h3 class="section-title">WORK EXPERIENCE</h3>

      <section
        class="experience"
        *ngIf="data.experience?.length"
      >
        <article
          class="exp-item"
          *ngFor="let exp of data.experience"
        >
          <div class="exp-head">
            <div class="job-title">{{ exp.Title }}</div>
            <div class="company">{{ exp.company }}</div>
          </div>

          <div class="meta">
            <span class="dates"
              >{{ exp.startDate }} -
              {{ exp.endDate ? exp.endDate : ' Present' }}</span
            >
            <span
              *ngIf="
                exp.joblocation &&
                (exp.joblocation.City || exp.joblocation.State)
              "
              class="location"
            >
              | {{ exp.joblocation.City }}
              <span *ngIf="exp.joblocation.City && exp.joblocation.State"
                >,
              </span>
              <span *ngIf="exp.joblocation.State">{{
                exp.joblocation.State
              }}</span>
            </span>
          </div>

          <ul class="desc-points">
            <li *ngFor="let p of exp.descriptionPoints">{{ p }}</li>
          </ul>
        </article>
      </section>
    </main>
  </div>
</div>
